<!-- <h1 mat-dialog-title>{{ 'LoginModal.AccountRegistration' | translate }}</h1> -->
<mat-dialog-content>
  <h1>{{ 'LoginModal.SessionTimeoutHeader' | translate }}</h1>
  <p>{{ 'LoginModal.SessionTimeoutParagraph' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="submit" class="mbfs-button" mat-dialog-close>{{ 'LoginModal.Close' | translate }}</button>
</mat-dialog-actions>